module.exports = __webpack_public_path__ + "static/media/close.47ce4f41.svg";